module.exports = __webpack_public_path__ + "static/media/coffee.b67cbcf5.svg";